((d, w) => {
  // helper function removes all "active" classes
  const resetTabsAndPanels = (panels, tabs) => {
    panels.forEach((panel) => panel.classList.remove("active"));
    tabs.forEach((tab) => tab.classList.remove("show"));
  };

  // helper function add the active class
  const setActive = (panel, tab) => {
    panel.classList.add("active");
    tab.classList.add("show");
    tab.scrollIntoView({ behavior: "smooth" });
  };

  // aka quicklinks or tiles
  const panels = Array.from(d.querySelectorAll(".block-quicklinks__item"));
  // associated content
  const tabs = Array.from(d.querySelectorAll(".tabbed-info"));

  panels.forEach((panel) => {
    panel.addEventListener("click", (e) => {
      // prevent links activating
      e.preventDefault();
      const link = panel.querySelector("a");
      if (link) {
        const href = link.getAttribute("href");
        const target = d.getElementById(href);
        resetTabsAndPanels(panels, tabs);
        setActive(panel, target);
      }
    });
  });
})(document, window);
